<div class="message error" *ngIf="type === 'error'">
  <div class="icon">
    <img src="assets/images/new-design-icons/error-sign.svg" alt="" srcset="">
  </div>
  <div class="title">{{ message }}</div>
</div>

<div class="message success" *ngIf="type === 'success'">
  <div class="icon">
    <img src="assets/images/new-design-icons/error-sign.svg" alt="" srcset="">
  </div>
  <div class="title">{{ message }}</div>
</div>
